(function(){
  'use strict';

  var CHAT_TRIGGER_SELECTOR = '[data-valse-open-chat], .valse-live-chat-link, a[href="#valse-live-chat"]';
  var CART_SAFE_SELECTOR = [
    '.btn-add-to-cart',
    '.btn-buy-now',
    '.product-card__button',
    '.valse-product-form__add',
    '.shopify-payment-button__button',
    '[data-buy-now-card]',
    '[data-product-card-form]',
    '.valse-product-form',
    'form[action*="/cart/add"]',
    'button[name="add"]',
    '[data-add-to-cart]',
    '[data-action="add-to-cart"]'
  ].join(',');

  function clickInsideShadow(host){
    if(!host || !host.shadowRoot) return false;
    var selectors = [
      '.chat-app > button',
      'button[aria-label*="chat" i]',
      'button[aria-label*="message" i]',
      'button[aria-label*="open" i]',
      'button'
    ];
    for(var i=0;i<selectors.length;i++){
      var button = host.shadowRoot.querySelector(selectors[i]);
      if(button){
        button.click();
        return true;
      }
    }
    return false;
  }

  function clickVisibleChatButton(){
    var hosts = [
      document.getElementById('ShopifyChat'),
      document.querySelector('shopify-chat'),
      document.querySelector('[id="shopify-chat"]'),
      document.querySelector('[id*="ShopifyChat"]'),
      document.querySelector('[data-shopify-chat]')
    ].filter(Boolean);

    for(var h=0; h<hosts.length; h++){
      if(clickInsideShadow(hosts[h])) return true;
      if(hosts[h].tagName && hosts[h].tagName.toLowerCase() === 'button'){
        hosts[h].click();
        return true;
      }
      var directButton = hosts[h].querySelector && hosts[h].querySelector('button');
      if(directButton){
        directButton.click();
        return true;
      }
    }

    return false;
  }

  function openValseLiveChat(event){
    if(event){
      event.preventDefault();
      event.stopPropagation();
    }

    if(clickVisibleChatButton()) return;

    var attempts = 0;
    var timer = window.setInterval(function(){
      attempts += 1;
      if(clickVisibleChatButton()){
        window.clearInterval(timer);
        return;
      }
      if(attempts >= 12){
        window.clearInterval(timer);
        if(window.location.search.indexOf('chat=1') === -1){
          var glue = window.location.search ? '&' : '?';
          window.location.href = window.location.pathname + window.location.search + glue + 'chat=1';
        }
      }
    }, 250);
  }

  function isLiveChatTrigger(el){
    if(!el || !el.matches) return false;
    if(el.closest && el.closest(CART_SAFE_SELECTOR)) return false;
    if(el.matches('[data-valse-open-chat]')) return true;
    if(el.matches('.valse-live-chat-link')) return true;
    var href = el.getAttribute('href') || '';
    return href === '#valse-live-chat' || href.indexOf('#valse-live-chat') !== -1;
  }

  document.addEventListener('click', function(event){
    var target = event.target;
    if(!target || !target.closest) return;

    // Never let live chat handling touch cart, checkout, buy-now, or product forms.
    if(target.closest(CART_SAFE_SELECTOR)) return;

    var trigger = target.closest(CHAT_TRIGGER_SELECTOR);
    if(isLiveChatTrigger(trigger)) openValseLiveChat(event);
  }, true);

  document.addEventListener('DOMContentLoaded', function(){
    var shouldAutoOpen = document.querySelector('[data-valse-auto-open-chat]') || window.location.hash === '#valse-live-chat' || window.location.search.indexOf('chat=1') !== -1;
    if(shouldAutoOpen){
      window.setTimeout(function(){ openValseLiveChat(); }, 700);
    }
  });

  window.valseOpenLiveChat = openValseLiveChat;
})();
